export default "__VITE_ASSET__CRboRjsJ__"